<app-element-loader
  [loadingMessage]="loadingMessage"
  [loadingStatus]="loadingStatus"
></app-element-loader>
<div class="modal-header modal-custom__header">
  <h4 class="modal-title" id="modal-basic-title"><i class="icon-pin"></i> Seleziona data?</h4>
  <button #close type="button" class="close modal-close" aria-label="close" (click)="modal.dismiss()">
    <span aria-hidden="true">Chiudi <i class="icon-close"></i></span>
  </button>
</div>
<div class="modal-body modal-custom__body">
  <ngb-datepicker #dp [(ngModel)]="selectedDateInternal" placeholder="yyyy-mm-dd"
                  [minDate]="minDate" [maxDate]="maxDate"
                  [markDisabled]="isDisabledDate" (dateSelect)="onDateSelected($event)"
                  name="dp" [displayMonths]="(isMobile$ | async) ? 1 : 2" [navigation]="'select'" [outsideDays]="'visible'" class="datepicker"
                  [showWeekNumbers]="false"></ngb-datepicker>
</div>
